import { IDictionary, isNullOrUndefined } from '@bimser/core';

const getMLText = (args: {
	data: IDictionary<any>;
	culture?: string;
	userCulture?: string;
	defaultCulture?: string;
	dontForce?: boolean;
	enableMultiLanguageText?: boolean;
}): string => {
	const { data, culture, userCulture, dontForce, enableMultiLanguageText, defaultCulture } = args;

	if (!enableMultiLanguageText) {
		return isNullOrUndefined(data['system']) ? undefined : data['system'];
	}

	let d = data[culture || userCulture];
	if (isNullOrUndefined(d) && !dontForce) {
		d = data[defaultCulture];
	}

	if (isNullOrUndefined(d) && !dontForce) {
		const keys = Object.keys(data);
		if (keys.length > 0) {
			d = data[keys[0]];
		}
	}

	return d || undefined;
};

export { getMLText };
